import appConfig from 'app.config'
import {
	IInformationModalProps,
	InformationModalProperties,
} from 'shared/interfaces/i-api-informationModal'

export function informationModalToClientFormat(
	information: InformationModalProperties,
): IInformationModalProps {
	const country = information.marketsAndLanguages[0]
		.split(':')[0]
		.toLowerCase()

	const currentDate = new Date()
	const startDate = new Date(information.activeFrom)
	const endDate = new Date(information.activeTo)

	const isActive = startDate <= currentDate && endDate >= currentDate

	return {
		country,
		active: isActive,
		headerTitle: information.headerTitle,
		headerImage: {
			src: `${appConfig.umbracoBaseUrl}${information.headerImage[0].url}`,
			alt: information.headerImage[0].name,
		},
		bodyTitle: information.bodyTitle,
		bodyText: information.bodyRichText.markup,
		ctaLink: information.ctaLink,
		ctaButtonText: information.ctaButtonText,
		css: 'mc-marketing',
		isCtaLinkInternalNavigation: information.isCtaLinkInternalNavigation,
		showFooterButtonClose: false,
	}
}
